var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.27,
    y: 391.21,
    width: 33.74,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.35,
    y: 391.08,
    width: 20.02,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.56,
    y: 397.64,
    width: 94.79,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.65,
    y: 388.97,
    width: 67.48,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.5,
    y: 391.19,
    width: 60.17,
    height: 0.25,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.47,318c-17.75-27.51-15.74,53.57-48.35,17.54-40.07-44.26-97.56-59.1-72.43-25.22s10.18,45.61-53.25,7.68c-46-27.51,38.83,55,15.6,51.83S56.57,359,86.62,382.32l194.94.08S291.22,345.48,273.47,318Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51,382.4H316.14c-22.6-15.57-35.18-57.27-3.39-102.59A158,158,0,0,1,332.45,257C344.48,320.65,396.32,363.52,359.51,382.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.44,382.4h43.37c20.13-11.51,26.05-42.33-12.95-75.83a187,187,0,0,0-23.34-16.86C284.63,336.76,239.63,368.44,279.44,382.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.76,382.4H354.89c-16.65-9.52-21.55-35,10.71-62.72a154.36,154.36,0,0,1,19.3-13.95C386.46,344.65,423.69,370.85,390.76,382.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,382.4s1-11.9,11.88-18a35.74,35.74,0,0,0-3.49,18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.33,382.4s-1-11.9-11.88-18a35.74,35.74,0,0,1,3.49,18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.44,382.4s-1-11.9-11.88-18a35.74,35.74,0,0,1,3.49,18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.26,382.4s-3.5-16.62-19.78-25.18a54,54,0,0,1,8.07,25.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.8,382.4s2.76-24.44-17.09-37c5.66,17.72-.13,37-.13,37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.77,382.4s5.6-20,25.87-30.24a68.86,68.86,0,0,0-11.8,30.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.7,382.4s.73-20,14-27.23c-5.92,10.25-5.58,27.23-5.58,27.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.72,382.4a13.31,13.31,0,0,1,6.44-9.77,19.34,19.34,0,0,0-1.89,9.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.55,382.4a13.31,13.31,0,0,0-6.44-9.77A19.34,19.34,0,0,1,219,382.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.33,382.4s.4-10.83,7.58-14.77c-3.21,5.56-3,14.77-3,14.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,382.4s.85-8.64-10-14.77c4.46,8.63,1.63,14.77,1.63,14.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.85,382.4s1-11.9,11.88-18a35.74,35.74,0,0,0-3.49,18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.79,382.4s-.73-20-14-27.23c5.92,10.25,5.58,27.23,5.58,27.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.53,185.92c3.61-4.56,10.88-8.09,16.25-7.87a6,6,0,0,1,4.33,1.64c9.81-5.68,21.1-9.18,30.42-8.79,4.74.19,8.43,1.36,11,3.27,10.53-8.58,24-14.66,33.7-14.66,5.53,0,9,2,10.2,5.25,10.81-5.75,21.91-9.29,30.87-9.29,14.27,0,18.91,9,13.07,21.61,2.34,2.37,13.6,5.7,13.14,9.68H52.9C53.1,186.48,53.3,186.21,53.53,185.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,107.06c2.65.13,4.5,1.1,5.52,2.67,13.36-9.26,28.43-14.94,40.56-14.31,6.2.3,10.91,2.22,14.05,5.33,0,0,0,0,0,0,14.52-14,32.63-23.83,45.38-23.83,7.25,0,11.57,3.2,12.85,8.54,14.66-9.39,29.5-15.14,41.22-15.14,14.52,0,20.94,8.84,18.94,22.45,7-4,13.87-6.29,19.47-6.29,7.76,0,11.39,4.48,10.76,11.49a16.75,16.75,0,0,1,2,.11c11.84,1.16,16.38,10.23,10.69,20.58H192.88C198.19,111.83,207.34,106.72,214,107.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.94,198a3.19,3.19,0,0,1,2.69,1.29c6.52-4.51,13.86-7.28,19.78-7a10.15,10.15,0,0,1,6.85,2.6h0c7.08-6.8,15.91-11.62,22.12-11.62,3.54,0,5.64,1.56,6.27,4.16,7.15-4.57,14.38-7.38,20.09-7.38,7.09,0,10.21,4.31,9.24,11,3.41-1.93,6.76-3.07,9.49-3.07,3.78,0,5.56,2.18,5.25,5.6.33,0,.66,0,1,0,5.77.57,8,5,5.2,10H325.66C328.25,200.31,332.71,197.82,335.94,198Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--social-tree--inject-1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 140.77,
    cy: 105.66,
    r: 10.14,
    transform: "translate(-33.48 130.49) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.77,
    cy: 105.66,
    r: 10.14,
    transform: "translate(-33.48 130.49) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.58,
    cy: 249.57,
    r: 10.14,
    transform: "translate(-54.63 44.16) rotate(-13.69)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.58,
    cy: 249.57,
    r: 10.14,
    transform: "translate(-54.63 44.16) rotate(-13.69)",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156.58,
    cy: 249.57,
    r: 10.14,
    transform: "translate(-54.63 44.16) rotate(-13.69)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.58,
    cy: 249.57,
    r: 10.14,
    transform: "translate(-54.63 44.16) rotate(-13.69)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 303.3,
    cy: 105.66,
    r: 12.67,
    transform: "translate(14.12 245.42) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.3,
    cy: 105.66,
    r: 12.67,
    transform: "translate(14.12 245.42) rotate(-45)",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 303.3,
    cy: 105.66,
    r: 12.67,
    transform: "translate(14.12 245.42) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.3,
    cy: 105.66,
    r: 12.67,
    transform: "translate(14.12 245.42) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 357.19,
    cy: 106.92,
    r: 11.41,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.19,
    cy: 106.92,
    r: 11.41,
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 357.19,
    cy: 106.92,
    r: 11.41,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357.19,
    cy: 106.92,
    r: 11.41,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 160.66,
    cy: 138.96,
    r: 16.79,
    transform: "translate(-47.45 96.36) rotate(-29.29)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.66,
    cy: 138.96,
    r: 16.79,
    transform: "translate(-47.45 96.36) rotate(-29.29)",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 160.66,
    cy: 138.96,
    r: 16.79,
    transform: "translate(-47.45 96.36) rotate(-29.29)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.66,
    cy: 138.96,
    r: 16.79,
    transform: "translate(-47.45 96.36) rotate(-29.29)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 213.95,
    cy: 77.54,
    r: 10.14,
    transform: "translate(85.81 265.59) rotate(-75.65)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.95,
    cy: 77.54,
    r: 10.14,
    transform: "translate(85.81 265.59) rotate(-75.65)",
    style: {
      fill: "#407BFF",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.95,
    cy: 77.54,
    r: 10.14,
    transform: "translate(85.81 265.59) rotate(-75.65)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.95,
    cy: 77.54,
    r: 10.14,
    transform: "translate(85.81 265.59) rotate(-75.65)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 143.87,
    cy: 189.29,
    r: 16.79,
    transform: "translate(-91.71 157.18) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.87,
    cy: 189.29,
    r: 16.79,
    transform: "translate(-91.71 157.18) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.5,
    cy: 81.25,
    r: 10.14,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.5,
    cy: 81.25,
    r: 10.14,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.14,
    cy: 98.04,
    r: 16.79,
    transform: "translate(93.73 315.62) rotate(-76.2)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.14,
    cy: 98.04,
    r: 16.79,
    transform: "translate(93.73 315.62) rotate(-76.2)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.24,
    cy: 240.55,
    r: 16.79,
    transform: "translate(-142.17 301.77) rotate(-76.81)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.24,
    cy: 240.55,
    r: 16.79,
    transform: "translate(-142.17 301.77) rotate(-76.81)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.36,
    cy: 86.26,
    r: 10.14,
    transform: "translate(170.04 387.15) rotate(-76.78)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.36,
    cy: 86.26,
    r: 10.14,
    transform: "translate(170.04 387.15) rotate(-76.78)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.08,
    cy: 147.73,
    r: 12.67,
    transform: "translate(-70.46 125.35) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.08,
    cy: 147.73,
    r: 12.67,
    transform: "translate(-70.46 125.35) rotate(-45)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28,242.7a7.21,7.21,0,1,0-10.75-.62c-.49.38-1,.77-1.43,1.17-.67.57-1.33,1.16-2,1.75s-1.29,1.2-1.92,1.82l-1,.92a1.69,1.69,0,0,0-.4.54,1.2,1.2,0,0,0-.11.35,1.43,1.43,0,0,0,0,.43,1.11,1.11,0,0,0,1,1,2,2,0,0,0,.44,0,2.06,2.06,0,0,0,.35-.12,1.76,1.76,0,0,0,.53-.4l.93-.94c.61-.63,1.21-1.28,1.81-1.92s1.18-1.32,1.75-2c.4-.47.79-.94,1.17-1.42A7.21,7.21,0,0,0,127.28,242.7Zm-9.12-1.07a5.7,5.7,0,1,1,8,0A5.69,5.69,0,0,1,118.16,241.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,108.56a4.77,4.77,0,1,0-7.11-.41c-.32.25-.63.5-.94.77s-.89.76-1.32,1.15l-1.27,1.2c-.21.2-.41.41-.62.62a1,1,0,0,0-.26.35,1,1,0,0,0-.1.52.73.73,0,0,0,.67.67.9.9,0,0,0,.29,0l.23-.08a1.14,1.14,0,0,0,.35-.26l.61-.63c.41-.41.81-.84,1.2-1.27s.78-.86,1.16-1.31.52-.62.77-.94A4.78,4.78,0,0,0,362.31,108.56Zm-6-.72a3.76,3.76,0,1,1,5.33,0A3.76,3.76,0,0,1,356.27,107.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53,107.18a4.44,4.44,0,1,0-6.62-.38c-.3.23-.59.47-.88.72s-.82.71-1.22,1.08-.8.74-1.19,1.11c-.19.19-.38.39-.58.58a1.12,1.12,0,0,0-.24.32.81.81,0,0,0-.07.22.76.76,0,0,0,0,.27.66.66,0,0,0,.62.62.76.76,0,0,0,.27,0,.81.81,0,0,0,.22-.07,1.12,1.12,0,0,0,.32-.24l.58-.58c.37-.39.75-.79,1.11-1.19s.73-.81,1.08-1.22.49-.58.72-.88A4.43,4.43,0,0,0,145.53,107.18Zm-5.62-.66a3.51,3.51,0,1,1,5,0A3.51,3.51,0,0,1,139.91,106.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.5,184.37a.52.52,0,0,0-.28-.55,8.72,8.72,0,0,0-3.51-.69,7.81,7.81,0,0,0-7.79,7.8c0,2.87,1.92,4.37,3.82,4.37a5,5,0,0,0,4.09-2,2.79,2.79,0,0,0,.65,1.16,2.74,2.74,0,0,0,2,.81c3,0,6-2.69,6-7.82a9,9,0,0,0-9.45-9.4c-6.69,0-11.74,5.3-11.74,12.32,0,5.86,4.13,10.11,9.83,10.11a11.66,11.66,0,0,0,5.71-1.29.5.5,0,0,0,.23-.62l-.49-1.32a.51.51,0,0,0-.29-.3.48.48,0,0,0-.42,0,9.23,9.23,0,0,1-4.4,1c-4.44,0-7.42-3.14-7.42-7.81,0-5.64,3.68-9.72,8.74-9.72,4.29,0,7,2.74,7,7.16a6.34,6.34,0,0,1-1.49,4.51,2,2,0,0,1-1.32.63.47.47,0,0,1-.4-.18c-.17-.22-.41-.85-.05-2.68Zm-4.16,1.39a5.07,5.07,0,0,1,1,.09l-.56,3c-.31,1.74-1.81,3.77-3.27,3.77S141,191.49,141,190.8C141,188.07,143,185.76,145.34,185.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.91,78.27a.29.29,0,0,0-.17-.33,5.2,5.2,0,0,0-2.12-.42,4.73,4.73,0,0,0-4.72,4.72,2.41,2.41,0,0,0,2.31,2.65,3,3,0,0,0,2.48-1.19,1.69,1.69,0,0,0,.39.7,1.65,1.65,0,0,0,1.22.49c1.8,0,3.62-1.63,3.62-4.74a5.47,5.47,0,0,0-5.73-5.69,7.13,7.13,0,0,0-7.11,7.46A5.84,5.84,0,0,0,278,88a7,7,0,0,0,3.46-.78.3.3,0,0,0,.15-.37l-.3-.8a.29.29,0,0,0-.18-.18.28.28,0,0,0-.25,0,5.66,5.66,0,0,1-2.67.61,4.37,4.37,0,0,1-4.49-4.73c0-3.41,2.23-5.88,5.29-5.88a4,4,0,0,1,4.21,4.33,3.84,3.84,0,0,1-.9,2.73,1.15,1.15,0,0,1-.8.38.28.28,0,0,1-.24-.1c-.11-.13-.25-.52,0-1.63Zm-2.51.84a2.78,2.78,0,0,1,.58.06L279.64,81c-.19,1.06-1.09,2.29-2,2.29s-.93-.7-.93-1.11A2.92,2.92,0,0,1,279.4,79.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.07,
    cy: 137.56,
    r: 16.79,
    transform: "translate(128.31 437.53) rotate(-76.62)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.07,
    cy: 137.56,
    r: 16.79,
    transform: "translate(128.31 437.53) rotate(-76.62)",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.7,132.63a.49.49,0,0,0-.28-.55,8.68,8.68,0,0,0-3.51-.69,7.81,7.81,0,0,0-7.8,7.8c0,2.88,1.93,4.38,3.83,4.38a5,5,0,0,0,4.1-2,2.68,2.68,0,0,0,.64,1.16,2.74,2.74,0,0,0,2,.81c3,0,6-2.69,6-7.83a9,9,0,0,0-9.46-9.41c-6.7,0-11.75,5.31-11.75,12.34,0,5.86,4.13,10.11,9.84,10.11a11.66,11.66,0,0,0,5.71-1.29.48.48,0,0,0,.24-.61l-.49-1.33a.48.48,0,0,0-.3-.29.51.51,0,0,0-.42,0,9.21,9.21,0,0,1-4.41,1c-4.43,0-7.42-3.14-7.42-7.82,0-5.64,3.68-9.73,8.75-9.73,4.29,0,7,2.75,7,7.17a6.41,6.41,0,0,1-1.49,4.52,1.92,1.92,0,0,1-1.33.62.47.47,0,0,1-.4-.17c-.17-.22-.41-.86,0-2.69ZM342.54,134a5.07,5.07,0,0,1,1,.09l-.56,3c-.31,1.75-1.81,3.78-3.27,3.78s-1.54-1.15-1.54-1.84C338.14,136.33,340.16,134,342.54,134Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.12,139s0,0,0-.06a9.78,9.78,0,0,0-.12-1.61,10.48,10.48,0,0,0-10.1-8.78h-.52a11.06,11.06,0,0,0-1.39.13,10.46,10.46,0,0,0-8.77,10.27s0,0,0,.05,0,0,0,.07a9.78,9.78,0,0,0,.12,1.61,10.49,10.49,0,0,0,10.3,8.79h.05A10.48,10.48,0,0,0,171.11,139S171.12,139,171.12,139Zm-2.75,4.14h-1.83a15.61,15.61,0,0,0,.49-3.29h2.34A8.69,8.69,0,0,1,168.37,143.1Zm-15.43-8.27h1.83a16.3,16.3,0,0,0-.48,3.29H152A8.63,8.63,0,0,1,152.94,134.83Zm12.35,2.67c0,.21,0,.41,0,.62h-3.82v-3.29h3.26A13.73,13.73,0,0,1,165.29,137.5Zm-3.78-4.37v-2.77a2.91,2.91,0,0,1,.7.36,6.18,6.18,0,0,1,1.91,2.41Zm-1.7-2.77v2.77h-2.62A5.17,5.17,0,0,1,159.81,130.36Zm0,4.47v3.29H156a14.68,14.68,0,0,1,.56-3.29Zm-7.8,5.54a5.32,5.32,0,0,1-.06-.56h2.34c0,.26,0,.51.05.77a15.22,15.22,0,0,0,.44,2.52h-1.84A8.65,8.65,0,0,1,152,140.37Zm4,.06c0-.21,0-.41,0-.62h3.82v3.29h-3.26A13.73,13.73,0,0,1,156,140.43Zm3.78,4.37v2.76a2.7,2.7,0,0,1-.7-.35,6.17,6.17,0,0,1-1.91-2.41Zm1.7,2.76V144.8h2.62A5.15,5.15,0,0,1,161.51,147.56Zm0-4.46v-3.29h3.81a14.14,14.14,0,0,1-.55,3.29Zm5.52-5c0-.26,0-.52-.05-.77a16.13,16.13,0,0,0-.44-2.52h1.84a8.82,8.82,0,0,1,.93,2.73c0,.19,0,.37.06.56Zm.16-5H166a11.38,11.38,0,0,0-.86-1.71c.22.14.45.28.66.44A8.53,8.53,0,0,1,167.19,133.13Zm-11-1.7a11.75,11.75,0,0,0-.86,1.7h-1.21A9,9,0,0,1,156.19,131.43Zm-2.06,13.37h1.21a10.54,10.54,0,0,0,.87,1.71A8.79,8.79,0,0,1,154.13,144.8Zm11,1.7a11.75,11.75,0,0,0,.86-1.7h1.2A8.94,8.94,0,0,1,165.13,146.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,86.2v0a8.93,8.93,0,0,0-.08-1,6.75,6.75,0,0,0-6.52-5.67h-.34a6.84,6.84,0,0,0-.89.08,6.75,6.75,0,0,0-5.66,6.63s0,0,0,0,0,0,0,0a6.15,6.15,0,0,0,.08,1A6.76,6.76,0,0,0,330.9,93h0a6.44,6.44,0,0,0,1.07-.09,6.76,6.76,0,0,0,5.67-6.62Zm-1.77,2.67h-1.18a10.32,10.32,0,0,0,.31-2.13h1.51A5.56,5.56,0,0,1,335.9,88.87Zm-10-5.34h1.18a10.94,10.94,0,0,0-.31,2.12H325.3A5.56,5.56,0,0,1,325.94,83.53Zm8,1.72c0,.14,0,.27,0,.4h-2.46V83.53h2.1A9,9,0,0,1,333.91,85.25Zm-2.44-2.82V80.64a2,2,0,0,1,.45.24,3.94,3.94,0,0,1,1.23,1.55Zm-1.1-1.78v1.78h-1.69A3.32,3.32,0,0,1,330.37,80.65Zm0,2.88v2.12h-2.46a9.39,9.39,0,0,1,.36-2.12Zm-5,3.57c0-.12,0-.24,0-.36h1.51l0,.5a10.45,10.45,0,0,0,.29,1.63h-1.19A5.53,5.53,0,0,1,325.34,87.1Zm2.6,0c0-.13,0-.26,0-.4h2.46v2.13h-2.1A8.55,8.55,0,0,1,327.94,87.14ZM330.37,90v1.79a2.4,2.4,0,0,1-.45-.23A4,4,0,0,1,328.69,90Zm1.1,1.79V90h1.69A3.34,3.34,0,0,1,331.47,91.75Zm0-2.88V86.74h2.46a9.48,9.48,0,0,1-.35,2.13ZM335,85.65l0-.5a11.39,11.39,0,0,0-.28-1.62h1.18a5.32,5.32,0,0,1,.6,1.76c0,.12,0,.24,0,.36Zm.11-3.22h-.79a7.06,7.06,0,0,0-.55-1.1l.43.28A5.92,5.92,0,0,1,335.14,82.43ZM328,81.34a7,7,0,0,0-.56,1.09h-.78A5.62,5.62,0,0,1,328,81.34ZM326.71,90h.78a7.2,7.2,0,0,0,.56,1.11A5.7,5.7,0,0,1,326.71,90Zm7.1,1.1a7.52,7.52,0,0,0,.55-1.1h.78A5.65,5.65,0,0,1,333.81,91.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.44,
    cy: 187.9,
    r: 16.79,
    transform: "translate(114.98 521.35) rotate(-76.62)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.35,180.48H379.54a3,3,0,0,0-3,3v8.16a3,3,0,0,0,3,3h11.6l-.08,2.85,2.93-2.85h1.36a3,3,0,0,0,3-3V183.5A3,3,0,0,0,395.35,180.48ZM379.18,184a.85.85,0,0,1,.85-.84h3.63a.84.84,0,0,1,0,1.68H380A.85.85,0,0,1,379.18,184Zm15.27,7.9h-6.29a.84.84,0,1,1,0-1.67h6.29a.84.84,0,1,1,0,1.67Zm0-3.53H380.87a.84.84,0,0,1,0-1.67h13.58a.84.84,0,1,1,0,1.67Zm0-3.53h-8a.84.84,0,0,1,0-1.68h8a.84.84,0,0,1,0,1.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.75,142.66H110.41a2.18,2.18,0,0,0-2.17,2.17v5.86a2.18,2.18,0,0,0,2.17,2.17h8.32l-.06,2,2.1-2h1a2.18,2.18,0,0,0,2.17-2.17v-5.86A2.18,2.18,0,0,0,121.75,142.66Zm-11.6,2.5a.61.61,0,0,1,.61-.61h2.61a.61.61,0,0,1,0,1.21h-2.61A.61.61,0,0,1,110.15,145.16Zm11,5.66h-4.52a.6.6,0,1,1,0-1.19h4.52a.6.6,0,1,1,0,1.19Zm0-2.53h-9.74a.6.6,0,0,1,0-1.2h9.74a.6.6,0,0,1,0,1.2Zm0-2.53h-5.77a.61.61,0,0,1,0-1.21h5.77a.61.61,0,0,1,0,1.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.55,73.26h-9.19A1.77,1.77,0,0,0,207.6,75v4.74a1.77,1.77,0,0,0,1.76,1.76h6.74l0,1.66,1.71-1.66h.79a1.77,1.77,0,0,0,1.76-1.76V75A1.77,1.77,0,0,0,218.55,73.26Zm-9.4,2a.49.49,0,0,1,.49-.49h2.12a.48.48,0,0,1,.48.49.49.49,0,0,1-.48.49h-2.12A.5.5,0,0,1,209.15,75.28ZM218,79.87h-3.66a.49.49,0,1,1,0-1H218a.49.49,0,0,1,0,1Zm0-2.05h-7.9a.49.49,0,0,1-.48-.49.48.48,0,0,1,.48-.48H218a.47.47,0,0,1,.48.48A.48.48,0,0,1,218,77.82Zm0-2h-4.68a.49.49,0,0,1-.48-.49.48.48,0,0,1,.48-.49H218a.48.48,0,0,1,.48.49A.49.49,0,0,1,218,75.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.04,
    cy: 105.66,
    r: 12.67,
    transform: "translate(-17.59 168.86) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.04,
    cy: 105.66,
    r: 12.67,
    transform: "translate(-17.59 168.86) rotate(-45)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,103.56c-3-.91-4.87-4.18-4.87-4.18s-1-.06-1,.8a4.27,4.27,0,0,0,1.25,3.12l-1.44-.08a4.92,4.92,0,0,0-1.53.16l-.48.13a1.59,1.59,0,0,0-1.12,1.91l.69,2.8a3.48,3.48,0,0,0,3.9,2.63c1.47-.21,3.76-.55,4.15-.62h0l1.05-.09.36-6.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.1,
    y: 102.69,
    width: 5.19,
    height: 8.3,
    rx: 0.57,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.1,
    y: 102.69,
    width: 5.19,
    height: 8.3,
    rx: 0.57,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.06,91.27H241.22a2.54,2.54,0,0,0-2.52,2.52v8.5a2.53,2.53,0,0,0,2.52,2.52h13.84a2.52,2.52,0,0,0,2.52-2.52v-8.5A2.53,2.53,0,0,0,255.06,91.27Zm-9.12,10.33V94.49L252.09,98Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.39,
    cy: 150.25,
    r: 10.14,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.39,
    cy: 150.25,
    r: 10.14,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.78,146.14h-8.4a1.54,1.54,0,0,0-1.53,1.53v5.16a1.54,1.54,0,0,0,1.53,1.53h8.4a1.54,1.54,0,0,0,1.53-1.53v-5.16A1.54,1.54,0,0,0,389.78,146.14Zm-5.54,6.27V148.1l3.73,2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.78,245.46h-8.4a1.53,1.53,0,0,0-1.52,1.53v5.16a1.52,1.52,0,0,0,1.52,1.52h8.4a1.53,1.53,0,0,0,1.53-1.52V247A1.54,1.54,0,0,0,160.78,245.46Zm-5.54,6.27v-4.32l3.74,2.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.13,
    cy: 193.41,
    r: 12.67,
    transform: "translate(-35.09 302.11) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.13,
    cy: 193.41,
    r: 12.67,
    transform: "translate(-35.09 302.11) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.13,185.75a7.58,7.58,0,0,0-1.73,14.95l1.73,2.2,1.73-2.2h0a7.57,7.57,0,0,0-1.73-14.95Zm0,10.73a3.16,3.16,0,1,1,3.16-3.16A3.15,3.15,0,0,1,347.13,196.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,98A7.58,7.58,0,0,0,301.57,113l1.73,2.2L305,113h0A7.57,7.57,0,0,0,303.3,98Zm0,10.73a3.16,3.16,0,1,1,3.16-3.16A3.15,3.15,0,0,1,303.3,108.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.25,210.08c-54.72-2.73-89.75,17.14-110.88,38.74,25.19-57.6,84.05-94.64,84.05-94.64-48.67,12.64-76.5,39.89-92.22,66.25,17.93-64.1,63.59-115.88,63.59-115.88-42,27-62.29,61.63-72.1,91.62C268.91,129.06,286.94,98,286.94,98s-33.63,11.54-36.88,109.53C246.82,109.58,213.19,98,213.19,98s18,31,22.24,98.13c-9.81-30-30.13-64.65-72.09-91.62,0,0,45.65,51.78,63.59,115.88-15.72-26.36-43.55-53.61-92.22-66.25,0,0,58.86,37,84,94.64-21.13-21.6-56.16-41.47-110.88-38.74,0,0,127.43,23.74,121.12,128.59-2,33.82-9.66,56-15.41,77.57h69.08c2-22.88-6.32-55-10.79-78.69C257.52,236.28,392.25,210.08,392.25,210.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.25,210.08c-54.72-2.73-89.75,17.14-110.88,38.74,25.19-57.6,84.05-94.64,84.05-94.64-48.67,12.64-76.5,39.89-92.22,66.25,17.93-64.1,63.59-115.88,63.59-115.88-42,27-62.29,61.63-72.1,91.62C268.91,129.06,286.94,98,286.94,98s-33.63,11.54-36.88,109.53C246.82,109.58,213.19,98,213.19,98s18,31,22.24,98.13c-9.81-30-30.13-64.65-72.09-91.62,0,0,45.65,51.78,63.59,115.88-15.72-26.36-43.55-53.61-92.22-66.25,0,0,58.86,37,84,94.64-21.13-21.6-56.16-41.47-110.88-38.74,0,0,127.43,23.74,121.12,128.59-2,33.82-9.66,56-15.41,77.57h69.08c2-22.88-6.32-55-10.79-78.69C257.52,236.28,392.25,210.08,392.25,210.08Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.98,
    cy: 245.37,
    r: 16.79,
    transform: "translate(-63.97 336.31) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.98,
    cy: 245.37,
    r: 16.79,
    transform: "translate(-63.97 336.31) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.67,242.39c-4.08-1.25-6.61-5.69-6.61-5.69s-1.29-.07-1.35,1.1A5.75,5.75,0,0,0,370.4,242l-2-.11a6.36,6.36,0,0,0-2.08.22l-.65.17a2.17,2.17,0,0,0-1.52,2.59l.94,3.81a4.73,4.73,0,0,0,5.29,3.57c2-.29,5.11-.74,5.65-.84h0l1.42-.12.49-8.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.78,
    y: 241.21,
    width: 7.05,
    height: 11.27,
    rx: 0.78,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.78,
    y: 241.21,
    width: 7.05,
    height: 11.27,
    rx: 0.78,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.9,
    cy: 192.02,
    r: 12.67,
    transform: "translate(-106.93 248.75) rotate(-76.64)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.9,
    cy: 192.02,
    r: 12.67,
    transform: "translate(-106.93 248.75) rotate(-76.64)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.39,189.9c-3-.92-4.86-4.19-4.86-4.19s-1-.05-1,.81a4.25,4.25,0,0,0,1.25,3.12l-1.44-.08a4.61,4.61,0,0,0-1.53.16l-.48.13a1.58,1.58,0,0,0-1.12,1.9l.69,2.81a3.47,3.47,0,0,0,1.57,2.15,3.53,3.53,0,0,0,2.33.48c1.47-.22,3.76-.55,4.15-.62h0l1-.09.35-6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.48,
    y: 189.03,
    width: 5.19,
    height: 8.3,
    rx: 0.57,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.48,
    y: 189.03,
    width: 5.19,
    height: 8.3,
    rx: 0.57,
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.42,339.92c-.16.84-.29,1.44-.45,2.14l-.51,2c-.35,1.32-.72,2.61-1.11,3.9-.81,2.56-1.69,5.09-2.67,7.57s-2,4.92-3.09,7.34c-.54,1.21-1.12,2.41-1.7,3.6l-.44.89-.24.5c-.13.25-.25.5-.39.72a11.7,11.7,0,0,1-1.88,2.43,16.48,16.48,0,0,1-4.28,3,27.36,27.36,0,0,1-4.26,1.67,46.15,46.15,0,0,1-8.28,1.61,77.45,77.45,0,0,1-16.11,0l.09-5.05c2.44-.26,5-.54,7.46-1s4.93-.84,7.31-1.39a46.2,46.2,0,0,0,6.77-2.1,12.46,12.46,0,0,0,4.75-3,2.72,2.72,0,0,0,.43-.67l.55-1.41c.46-1.17.9-2.35,1.35-3.53.9-2.35,1.72-4.73,2.53-7.1s1.57-4.75,2.27-7.13c.37-1.18.71-2.37,1-3.55l.46-1.77.4-1.63Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.6,327.37c-4,1-6.84,17.59-6.84,17.59l11.09,7.54s10.64-16.71,7.54-21.13C209.17,326.76,206.48,325.88,200.6,327.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.6,327.37c-4,1-6.84,17.59-6.84,17.59l11.09,7.54s10.64-16.71,7.54-21.13C209.17,326.76,206.48,325.88,200.6,327.37Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.24,333.39l8.61,2,.83,8.42a97.38,97.38,0,0,1-4.83,8.69l-6.73-4.57C198.41,344.06,199.14,336,200.24,333.39Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.06,351a.28.28,0,0,1-.15,0l-11.82-8a.27.27,0,0,1-.07-.37.26.26,0,0,1,.36-.07l11.83,8a.27.27,0,0,1,.07.37A.27.27,0,0,1,206.06,351Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.6,327.37S196,329,205.27,386.31h39.66c-.67-16.14-.69-26.1,7-59.22a116.77,116.77,0,0,0-16.84-2.22,125.74,125.74,0,0,0-18,0C209.37,325.58,200.6,327.37,200.6,327.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.6,327.37S196,329,205.27,386.31h39.66c-.67-16.14-.69-26.1,7-59.22a116.77,116.77,0,0,0-16.84-2.22,125.74,125.74,0,0,0-18,0C209.37,325.58,200.6,327.37,200.6,327.37Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9,397.48c-1-12.83-19.25-12.22-31.56-10.64l-1.67.23c-.36-.78-1.24-1.15-2.7-.94-10.06-.25-23.65.18-23.65.18-6.4-1.35-18.76-2.24-28.15-2.29-8.91-.06-21.34,0-27.85,1.86-5.7,1.65-11.51,2.82-12.57,8s.13,17.56,10.38,20c11.37,2.73,25.15,3.68,37.28,5.83,0,0,1.26-4.33,3.26-10.19l.24.1H192a46.4,46.4,0,0,0,10.32.4,4.34,4.34,0,0,1,4.58,3.6v0c.86,5.16,6.05,11.21,30.12,10.5S269.94,410.31,268.9,397.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9,397.48c-1-12.83-19.25-12.22-31.56-10.64l-1.67.23c-.36-.78-1.24-1.15-2.7-.94-10.06-.25-23.65.18-23.65.18-6.4-1.35-18.76-2.24-28.15-2.29-8.91-.06-21.34,0-27.85,1.86-5.7,1.65-11.51,2.82-12.57,8s.13,17.56,10.38,20c11.37,2.73,25.15,3.68,37.28,5.83,0,0,1.26-4.33,3.26-10.19l.24.1H192a46.4,46.4,0,0,0,10.32.4,4.34,4.34,0,0,1,4.58,3.6v0c.86,5.16,6.05,11.21,30.12,10.5S269.94,410.31,268.9,397.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.52,384l.32,3.55c.14.28-.19.56-.65.56H205.07c-.35,0-.65-.18-.67-.4l-.36-3.55c0-.25.28-.46.68-.46h40.16A.71.71,0,0,1,245.52,384Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.52,384l.32,3.55c.14.28-.19.56-.65.56H205.07c-.35,0-.65-.18-.67-.4l-.36-3.55c0-.25.28-.46.68-.46h40.16A.71.71,0,0,1,245.52,384Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.13,388.47h1.07c.22,0,.38-.11.37-.24l-.51-4.62c0-.13-.2-.24-.41-.24h-1.08c-.21,0-.38.11-.36.24l.5,4.62C239.73,388.36,239.91,388.47,240.13,388.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1,388.47h1.07c.22,0,.38-.11.36-.24l-.5-4.62c0-.13-.2-.24-.42-.24h-1.07c-.22,0-.38.11-.37.24l.51,4.62C207.69,388.36,207.88,388.47,208.1,388.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.11,388.47h1.08c.21,0,.37-.11.36-.24l-.5-4.62c0-.13-.21-.24-.42-.24h-1.08c-.21,0-.37.11-.36.24l.51,4.62C223.71,388.36,223.9,388.47,224.11,388.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.13,388.47h1.07c.22,0,.38-.11.37-.24l-.51-4.62c0-.13-.2-.24-.41-.24h-1.08c-.21,0-.38.11-.36.24l.5,4.62C239.73,388.36,239.91,388.47,240.13,388.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.1,388.47h1.07c.22,0,.38-.11.36-.24l-.5-4.62c0-.13-.2-.24-.42-.24h-1.07c-.22,0-.38.11-.37.24l.51,4.62C207.69,388.36,207.88,388.47,208.1,388.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.11,388.47h1.08c.21,0,.37-.11.36-.24l-.5-4.62c0-.13-.21-.24-.42-.24h-1.08c-.21,0-.37.11-.36.24l.51,4.62C223.71,388.36,223.9,388.47,224.11,388.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M163.54,372.19l-6.93-7-.91,9.89s5.2,3.51,8.79,1.62Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.47 364.12 148.16 372.44 155.7 375.06 156.61 365.17 148.47 364.12",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.63,342.47l5.11,4.35c-1.09,5.8-1.82,10.63-2.29,14.92C244.49,357.43,242.06,345.76,242.63,342.47Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.66,314.93c-3.1-5.41-6.16-11.95-3.25-21.09,3.34-10.5,1.52-15.69-.59-18.2-1.91-2.27-4.92-3.29-8.5-2.91a6.66,6.66,0,0,0-5.06,2.42s-15.46,1.32-25.36,12.75c3.2,9.31-1.38,20.63-7.27,24.93,18.77,15.91,38.89,10.93,45.47,8,3.16-1.42,4.28-3.39,3.59-6.57l.54.95a.24.24,0,0,0,.21.13.28.28,0,0,0,.13,0A.25.25,0,0,0,246.66,314.93Zm-4.22-39a9.89,9.89,0,0,1,2,4.5,12.31,12.31,0,0,0-7.06-7.19A8,8,0,0,1,242.44,276Zm-.25,17.17a24.17,24.17,0,0,0,2.1-4.82,42.85,42.85,0,0,1-1.36,5.38,22.43,22.43,0,0,0-.55,12.54C240.7,302,239.87,297.27,242.19,293.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1,302.85a1.26,1.26,0,0,1-2.52,0,1.26,1.26,0,1,1,2.52,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.77,334.17c-1.89,0-7.63,0-9.59-4.07a6.33,6.33,0,0,1-.11-4.94.27.27,0,0,1,.34-.16.27.27,0,0,1,.16.34,5.83,5.83,0,0,0,.08,4.53c1.82,3.78,7.31,3.78,9.12,3.78,12.84,0,15.06-7.7,15.15-8l.16-.61a.27.27,0,0,1,.32-.19.26.26,0,0,1,.19.33l-.16.6C238.33,326.11,236,334.17,222.77,334.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.33,304.59c-1.13,5.8-2.27,16.41,1.79,20.28,0,0-1.59,5.88-12.35,5.88-10.36,0-5.66-5.88-5.66-5.88,6.46-1.54,6.29-6.34,5.17-10.84Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.83,308.44,222.28,314a18.89,18.89,0,0,1,.56,3.19c2.47-.35,5.86-3.06,6.12-5.65A8.72,8.72,0,0,0,228.83,308.44Z",
    style: {
      fill: "#ce6f64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,289.32c1.12,9.63,1.8,13.68-2.13,19.43-5.92,8.65-18,7.91-22-1.18-3.58-8.19-4.81-22.56,3.84-28A13.21,13.21,0,0,1,234,289.32Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.81,281.07c-2.19,4.22-18.16,9.29-25.78,8.82a11.87,11.87,0,0,0,3-2.17c0-3.29,0-10.47,4.92-14.56a22.82,22.82,0,0,1,21.43-4.55,9.24,9.24,0,0,1,6.21,6.05l.54,1.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.21,277.83,224,280.21s-2.78,14.87,10.85,14.49C234.8,294.7,234.67,280,228.21,277.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.08,296.11a7.37,7.37,0,0,1-2.5,4.8c-1.89,1.6-3.77.18-4-2.12-.23-2.08.46-5.41,2.73-6.12S238.29,293.84,238.08,296.11Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.79,418.25l2.82-10.6a.77.77,0,0,1,.84-.59l8.71,1a1.56,1.56,0,0,1,1.28,2c-1.05,3.68-1.74,5.4-3,10.06-.76,2.87-2,8.88-3.09,12.84s-5,3.13-5,1.39c.38-7.82-1-11.31-2.47-14.36A2.54,2.54,0,0,1,189.79,418.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.3,420.45l2.82-10.6a.78.78,0,0,0-.44-.93l-8.07-3.44a1.57,1.57,0,0,0-2.08,1.06c-.92,3.72-1.18,5.56-2.42,10.22-.76,2.87-2.64,8.72-3.7,12.68s2.81,5.22,3.6,3.66c3.56-7,6.53-9.3,9.29-11.23A2.6,2.6,0,0,0,211.3,420.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.05,294.57c.14.78-.16,1.48-.67,1.57s-1-.47-1.17-1.24.16-1.48.67-1.57S219.91,293.79,220.05,294.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.28,296.14c.14.77-.16,1.47-.66,1.57s-1-.47-1.17-1.24.16-1.48.66-1.57S211.15,295.36,211.28,296.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,294.9l-2-.2S209.6,296,210.35,294.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.84,297.06A21.07,21.07,0,0,1,212,302.5a3.4,3.4,0,0,0,2.86,0Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.81,304.66a.14.14,0,0,1-.05-.28,6.57,6.57,0,0,0,3.46-3.26.14.14,0,0,1,.19-.08.15.15,0,0,1,.08.2,6.77,6.77,0,0,1-3.63,3.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.12,289.6a.37.37,0,0,1-.2-.07,3.81,3.81,0,0,0-3.38-.9.3.3,0,0,1-.37-.2.31.31,0,0,1,.2-.37,4.45,4.45,0,0,1,3.94,1,.29.29,0,0,1,0,.41A.29.29,0,0,1,221.12,289.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.28,293a.32.32,0,0,1-.17-.06.3.3,0,0,1-.07-.41,4.42,4.42,0,0,1,3.55-2,.3.3,0,0,1,.29.3.34.34,0,0,1-.31.29,3.8,3.8,0,0,0-3,1.72A.31.31,0,0,1,206.28,293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.11,293.33l-2-.2S218.37,294.41,219.11,293.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,338c1,2.92,1.87,5.79,2.73,8.71s1.57,5.87,2.27,8.85,1.3,6,1.75,9.14c.23,1.56.41,3.15.5,4.83,0,.84.06,1.7,0,2.6l0,.69,0,.38-.05.52a10.17,10.17,0,0,1-.43,2,13.33,13.33,0,0,1-3.63,5.48,26.45,26.45,0,0,1-4.25,3.22,52.11,52.11,0,0,1-8.71,4.13,96.28,96.28,0,0,1-17.81,4.71l-1.21-4.9a153,153,0,0,0,16-6.75,49.23,49.23,0,0,0,7-4.22,16.83,16.83,0,0,0,2.69-2.37,4.85,4.85,0,0,0,1.18-2,20.89,20.89,0,0,0-.18-2.72c-.16-1.29-.4-2.65-.67-4-.53-2.74-1.24-5.54-2-8.33s-1.55-5.6-2.38-8.39-1.7-5.63-2.54-8.35Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.86,388.65l-9.27-2.34L224,395.2s6.26.27,8.33-3.22Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.11 389.69 216.21 396.93 224.01 395.2 219.59 386.31 212.11 389.69",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.76 420.14 193.42 406.41 188.6 404.42 181.81 419.16 189.76 420.14",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.76 420.14 193.42 406.41 188.6 404.42 181.81 419.16 189.76 420.14",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.85 420.32 213.15 407.46 218.77 407.25 218.33 423.62 210.85 420.32",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.85 420.32 213.15 407.46 218.77 407.25 218.33 423.62 210.85 420.32",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.62,424.51a1.26,1.26,0,0,1-.49-.1.68.68,0,0,1-.45-.49c-.31-1.29,2.59-4.51,2.92-4.88a.17.17,0,0,1,.18,0,.16.16,0,0,1,.1.17c-.1,1.59-.44,4.38-1.61,5.14A1.18,1.18,0,0,1,188.62,424.51Zm1.9-4.88c-1,1.14-2.73,3.37-2.52,4.22a.36.36,0,0,0,.25.26.89.89,0,0,0,.84-.08C189.8,423.57,190.32,421.94,190.52,419.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.87,421.53a1,1,0,0,1-.4-.07c-.22-.1-.47-.35-.37-.94a1.58,1.58,0,0,1,.69-1.09c1.28-.91,3.85-.46,4-.44a.16.16,0,0,1,.12.11.18.18,0,0,1,0,.16C190.14,420.12,188,421.53,186.87,421.53Zm2.31-2.34a4,4,0,0,0-2.2.51,1.27,1.27,0,0,0-.56.87c-.07.47.12.56.18.59.67.3,2.81-.87,3.79-1.89A10.84,10.84,0,0,0,189.18,419.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.81,426.63h-.14a1.21,1.21,0,0,1-.93-.66c-.64-1.24.45-3.83,1.15-5.26a.17.17,0,0,1,.31,0c.11.48,1,4.72.1,5.68A.65.65,0,0,1,209.81,426.63Zm.17-5.35c-.53,1.16-1.48,3.5-.95,4.53a.9.9,0,0,0,.69.49.36.36,0,0,0,.35-.11C210.67,425.56,210.27,422.77,210,421.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,424.88h-.06c-1.09-.11-2.5-2.84-2.71-4.08a.14.14,0,0,1,.06-.15.15.15,0,0,1,.16,0c.1,0,2.56.92,3.22,2.34a1.65,1.65,0,0,1,.05,1.29C213.18,424.76,212.89,424.88,212.65,424.88ZM210.26,421c.36,1.37,1.63,3.44,2.36,3.51.07,0,.28,0,.44-.41a1.26,1.26,0,0,0,0-1C212.54,422.07,210.92,421.31,210.26,421Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,327.09c4,1.21,10,16.8,10,16.8l-15.41,11s-6.93-13.33-5.26-18.47C243.08,331.09,247.42,325.71,252,327.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,327.09c4,1.21,10,16.8,10,16.8l-15.41,11s-6.93-13.33-5.26-18.47C243.08,331.09,247.42,325.71,252,327.09Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.67,353.28a.27.27,0,0,1-.16-.48l15.54-11.11a.25.25,0,0,1,.36.06.26.26,0,0,1-.06.37l-15.53,11.11A.23.23,0,0,1,245.67,353.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.21 358.9 203.81 358.9 213.9 400 144.3 400 134.21 358.9",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.47 392.34 212.04 402.27 239.36 394.61 239.08 392.34 169.47 392.34",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.07 358.9 201.67 358.9 211.75 400 142.16 400 132.07 358.9",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.07 358.9 201.67 358.9 211.75 400 142.16 400 132.07 358.9",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.16 400 142.44 402.27 212.04 402.27 211.76 400 142.16 400",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.16 400 142.44 402.27 212.04 402.27 211.76 400 142.16 400",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.565fa204bf283098818624fa1db55438.svg";
export { ForwardRef as ReactComponent };